<template>
<footer class="footer footer-transparent">
  <div class="container" style="width: calc(100% - 260px);">
    <div class="copyright">
      Desenvolvido por 3E Engenharia {{versionNumber}}
    </div>
  </div>
</footer>
</template>
<script>
  export default {
    name: 'content-footer',
    computed: {
      versionNumber: function () {
        return process.env.VERSION || ''
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue